import { EvaluationResponseStatus } from 'enum/evaluationResponseStatus.enum'
import { IEvaluationResume } from 'models/evaluation.model'

export function createInitialEvaluationResume(): IEvaluationResume {
  return {
    id: 0,
    name: '',
    description: '',
    status: EvaluationResponseStatus.notStarted,
    approved: false,
    totalQuestions: 0,
    versionId: 0,
    versionNumber: 0,
    showResults: false,
    minimumPassingScore: 0,
    totalPossiblePoints: 0,
    multipleRetries: false,
    maxRetries: 0,
    attemptsRemaining: 0,
    obtainedPoints: 0,
    correctAnswers: 0,
    completionDate: null,
    required: true,
    approvalRequired: true,
  }
}
